export const VOLUME_LISTENER = {
    eventName: 'onVolumeChange',
    listener: 'onvolumechange'
}

export const EVENTS_TYPE = {
    paused: 'paused',
    playing: 'playing',
    ended: 'ENDED'
}